import API from "../../utils/endpoints";
import history from "../../history";
import * as types from "./actionType";
import { toast } from "react-toastify";
import axios from "axios";

import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingTestimonialList() {
  return {
    type: types.FETCH_TESTIMONIALS_LIST,
  };
}

function fetchingTestimonialListSuccess(payload, count, pendingCount) {
  return {
    type: types.FETCH_TESTIMONIALS_LIST_SUCCESS,
    payload,
    count,
    pendingCount,
  };
}

function fetchingTestimonialListFailed() {
  return {
    type: types.FETCH_TESTIMONIALS_LIST_FAILED,
  };
}

function fetchingTestimonialDetails() {
  return {
    type: types.FETCH_TESTIMONIALS_DETAILS,
  };
}

function fetchingTestimonialDetailsSuccess(payload, count) {
  return {
    type: types.FETCH_TESTIMONIALS_DETAILS_SUCCESS,
    payload,
    count,
  };
}

function fetchingTestimonialDetailsFailed() {
  return {
    type: types.FETCH_TESTIMONIALS_DETAILS_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

function fetchingCity() {
  return {
    type: types.FETCH_CITY,
  };
}

function fetchingCitySuccess(payload) {
  return {
    type: types.FETCH_CITY_SUCCESS,
    payload,
  };
}

function fetchingCityFailed() {
  return {
    type: types.FETCH_CITY_FAILED,
  };
}

function creatingTestimonial() {
  return {
    type: types.CREATE_TESTIMONIAL,
  };
}

function creatingTestimonialSuccess(payload, count) {
  return {
    type: types.CREATE_TESTIMONIAL_SUCCESS,
    payload,
    count,
  };
}

function creatingTestimonialFailed() {
  return {
    type: types.CREATE_TESTIMONIAL_FAILED,
  };
}

function updatingTestimonial() {
  return {
    type: types.UPDATE_TESTIMONIAL,
  };
}

function updatingTestimonialSuccess(payload, count) {
  return {
    type: types.UPDATE_TESTIMONIAL_SUCCESS,
    payload,
    count,
  };
}

function updatingTestimonialFailed() {
  return {
    type: types.UPDATE_TESTIMONIAL_FAILED,
  };
}

function uploadUrlRequest() {
  return {
    type: types.UPLOAD_URL,
  };
}

function uploadUrlSuccess(payload) {
  return {
    type: types.UPLOAD_URL_SUCCESS,
    payload,
  };
}

function uploadUrlFailed() {
  return {
    type: types.UPLOAD_URL_FAILED,
  };
}

function readUrlRequest() {
  return {
    type: types.READ_URL,
  };
}

function readUrlSuccess(payload) {
  return {
    type: types.READ_URL_SUCCESS,
    payload,
  };
}

function readUrlFailed() {
  return {
    type: types.READ_URL_FAILED,
  };
}

function uploadBinaryUrlRequest() {
  return {
    type: types.UPLOAD_BINARY_URL,
  };
}

function uploadBinaryUrlSuccess(payload) {
  return {
    type: types.UPLOAD_BINARY_URL_SUCCESS,
    payload,
  };
}

function uploadBinaryUrlFailed() {
  return {
    type: types.UPLOAD_BINARY_URL_FAILED,
  };
}

function fetchingTestimonialUpdatedDetails() {
  return {
    type: types.TESTIMONIAL_UPDATE_DETAILS,
  };
}

function fetchingTestimonialUpdatedDetailsSuccess(payload, count) {
  return {
    type: types.TESTIMONIAL_UPDATE_DETAILS_SUCCESS,
    payload,
    count,
  };
}

function fetchingTestimonialUpdatedDetailsFailed() {
  return {
    type: types.TESTIMONIAL_UPDATE_DETAILS_FAILED,
  };
}

export function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

export const fetchTestimonialList = (payload, data) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingTestimonialList());
  try {
    let response = await api.get(
      `${API.fetchTestimonialList}?page=${payload.page}&limit=${payload.limit}&status=${payload.status}&country=${payload.country}&email=${payload.email}&mobile=${payload.phone}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingTestimonialListSuccess(
          response.data.data.testimonialData,
          response.data.data.count,
          response.data.data.pendingCount
        )
      );
    } else {
      dispatch(fetchingTestimonialListFailed());
      if (!data) {
        toast.error(response.data.message);
      }
    }
  } catch (error) {
    dispatch(fetchingTestimonialListFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchTestimonialDetails = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingTestimonialDetails());
  try {
    let response = await api.get(
      `${API.fetchTestimonialDeatils}?testimonialId=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingTestimonialDetailsSuccess(
          response.data.data,
          response.data.count
        )
      );
    } else {
      dispatch(fetchingTestimonialDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingTestimonialDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(`${API.fetchDealerState}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
    toast.error(errorMessage);
  }
};

//****** Fetching City  ********//

export const fetchCity = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCity());
  try {
    let response = await api.get(
      `${API.fetchDealerCity}?country=${payload.countryCode}&stateName=${payload.state} `
    );

    if (response.data.code === 200) {
      dispatch(fetchingCitySuccess(response.data.data));
    } else {
      dispatch(fetchingCityFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingCityFailed(errorMessage));
  }
};

export const createTestimonial = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(creatingTestimonial());

  console.log(payload);

  try {
    let response = await api.post(API.createTestimonials, payload);
    if (response.data.code === 200) {
      dispatch(
        creatingTestimonialSuccess(
          response.data.data.testimonialData,
          response.data.data.count
        )
      );
      callback && callback();
      toast.error(response.data.message);
    } else {
      dispatch(creatingTestimonialFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingTestimonialFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const updateTestimonial = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(updatingTestimonial());

  try {
    let response = await api.put(API.updateTestimonials, payload);
    if (response.data.code === 200) {
      dispatch(updatingTestimonialSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      dispatch(updatingTestimonialFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingTestimonialFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadUrlRequest());
  try {
    let response = await api.post(API.uploadUrl, {
      name: payload.name,
      extension: payload.type.slice(payload.type.lastIndexOf("/") + 1),
      category: "userTransfer",
    });
    if (response.data.code === 200) {
      dispatch(uploadUrlSuccess(response.data.data));
      dispatch(uploadBinaryUrl(response.data.data, payload, callback));
    } else {
      dispatch(uploadUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const uploadBinaryUrl = (data, payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(uploadBinaryUrlRequest());
  try {
    let response = await axios.put(data.uploadURL, payload, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
      },
    });
    console.log("res", response.status);
    if (response.status === 201) {
      dispatch(uploadBinaryUrlSuccess(response.data.data));
      dispatch(readUrl(data.filePath, callback));
    } else {
      dispatch(uploadBinaryUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(uploadBinaryUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const readUrl = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(readUrlRequest());
  try {
    let response = await api.get(`${API.readUrl}?path=${payload}`);
    if (response.data.code === 200) {
      let prevData = getState().VinLookup.documentRead;
      let newData = [...prevData, response.data.data.blobPath];
      dispatch(readUrlSuccess(newData));
      callback && callback(response.data.data.blobPath);
    } else {
      dispatch(readUrlFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(readUrlFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const ApproveImage = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(`${API.testimonialGalleryApprove} `, payload);

    if (response.data.code === 200) {
      // dispatch(createPartnerSuccess(response.data.data));
      // history.push("/partner/rentals");
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteTestimonial = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(deletingTourInfo());

  console.log(payload);

  try {
    let response = await api.delete(
      `${API.createTestimonials}?testimonialId=${payload.testimonialId}&status=${payload.status}&rejectionReason=${payload.rejectionReason}`
    );
    if (response.data.code === 200) {
      // dispatch(deletingTourInfoSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
    } else {
      // dispatch(deletingTourInfoFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(deletingTourInfoFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const ApproveRejectTestimonial = (payload) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(API.fetchTestimonialList, payload);

    if (response.data.code === 200) {
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      history.push("/moderation/testimonials");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const updateTestimonialDetails = (
  payload,
  callback
) => async (dispatch, getState, api) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(
      `${API.updateTestimonialsDeatils}`,
      payload
    );

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const approveRejectUpdatedTestimonialDetails = (
  payload,
  callback
) => async (dispatch, getState, api) => {
  // dispatch(createPartner());
  try {
    let response = await api.put(API.updateTestimonialsDeatils, payload);

    if (response.data.code === 200) {
      dispatch(fetchUpdatedTestimonailData(payload.testimonialId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteUpdatedTestimonialDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.delete(
      `${API.updateTestimonialsDeatils}?testimonialId=${payload.testimonialId}&key=${payload.key}`
    );
    if (response.data.code === 200) {
      dispatch(fetchUpdatedTestimonailData(payload.testimonialId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchUpdatedTestimonailData = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingTestimonialUpdatedDetails());
  try {
    let response = await api.get(
      `${API.updateTestimonialsDeatils}?testimonialId=${payload}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingTestimonialUpdatedDetailsSuccess(response.data.data));
    } else {
      dispatch(fetchingTestimonialUpdatedDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingTestimonialUpdatedDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};
